import Alpine from "alpinejs";

type OpenHour = {
    day: string,
    startTime: string,
    endTime: string,
    open: string,
    close: string
}

type OpenHourRow = {
    day: string,
    open: string,
    close: string
}

type StoreHoursConfig = {
    openHours: OpenHour[]
}

Alpine.data("storeHours", (config: StoreHoursConfig) => ({
    days: [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
    ],
    status: {
        isOpen: false,
        closingTime: '',
        opensNext: ''
    },
    open: false,
    operationTimes: config.openHours,
    openHourRows: [] as OpenHourRow[],
    getPresentationHour(dateTime: Date) {
        const hour = dateTime.getHours()
        const minute = dateTime.getMinutes()
        const postFix = hour >= 12 ? 'pm' : 'am'
        if (hour > 12) {
            return `${hour - 12}:${minute >= 1 ? minute : '00'}${postFix}`
        }
        return `${hour}:${minute >= 1 ? minute : '00'}${postFix}`
    },
    getParseHours(day: OpenHour) {
        const open = new Date(day.open)
        const close = new Date(day.close)
        const openHour = open.getHours();
        const closeHour = close.getHours();
        return {
            open: {
                hour: openHour,
                toString: this.getPresentationHour(open)
            },
            close: {
                hour: closeHour,
                toString: this.getPresentationHour(close)
            }
        }
    },

    parseOpenTime() {
        this.openHourRows = this.operationTimes
            .map((times) => {
                const { open, close } = this.getParseHours(times)
                return {
                    day: times.day,
                    open: open.toString,
                    close: close.toString,
                }
            }) as OpenHourRow[]
    },

    init() {

        // Get clients day
        const now = new Date();
        const day = now.getDay();

        // If no hours have been set for the store assume its closed. // 
        if (!this.operationTimes.length) {
            this.status = {
                isOpen: false,
                closingTime: '',
                opensNext: ''
            }
            return;
        }
        this.parseOpenTime()
        const openDay = this.getDay(day)

        if (!openDay) {
            const opensNext = this.operationTimes[0];
            const getOpen = this.getParseHours(opensNext)

            this.status = {
                isOpen: false,
                closingTime: '',
                opensNext: `${opensNext.day} at ${opensNext.startTime}`
            }
            return;
        }
        const currentHour = now.getHours()
        const { open, close } = this.getParseHours(openDay)
        if (currentHour >= open.hour && currentHour < close.hour) {
            this.status = {
                isOpen: true,
                closingTime: `at ${openDay.endTime}`,
                opensNext: ''
            }
            return;
        }
        // check if customer is visiting the page before the store is open for that day.
        if (currentHour < open.hour) {
            this.status = {
                isOpen: false,
                closingTime: ``,
                opensNext: `${open.toString} today`
            }
            return;
        }


        const opensNext = this.getNextDay(day);
        const nextDayHours = this.getParseHours(openDay)

        this.status = {
            isOpen: false,
            closingTime: '',
            opensNext: `${opensNext.day} at ${nextDayHours.open.toString}`
        }

    },


    getDay(day: number) {
        const dayName = this.days.at(day)
        return this.operationTimes.find(openDay => openDay.day.toLowerCase() === dayName)
    },

    getNextDay(day: number): OpenHour {
        const dayName = this.days.at(day + 1) ?? this.days.at(0)
        if (!dayName) throw 'No Day found.'
        const nextDay = this.operationTimes.find(openDay => openDay.day.toLowerCase() === dayName)
        if (!nextDay) {
            // if no next day is found then next day should be whatever the first entry is.
            return this.operationTimes[0]
        }
        return nextDay
    },

    show: {
        [':data-ui']() {
            return this.open && 'hidden'
        }
    },
    toggle: {
        ['@click']() {
            this.open = !this.open;
        }
    }


}))